import { OverlayAnnotations } from '@readcloud/common';
import { Button, Card, Modal } from '@readcloud/component-library';
import React from 'react';
import FroalaEditorView from 'react-froala-wysiwyg/FroalaEditorView';
import { useModalState } from '../../hooks/useModalState';
import { InteractionPreventer } from '../InteractionDisabler';
import { AnnotationRendererProps } from '../types';
import { froalaConfig } from './config';
import { P } from '@readcloud/ui/typography';

const cardStyle = {
  height: '100%',
  width: '100%',
  transition: 'box-shadow 100ms ease-out',
  overflow: 'hidden',
} as const;

export const HTMLAnnotationViewer = React.memo(function HTMLAnnotationViewer(
  props: AnnotationRendererProps<
    OverlayAnnotations.HTMLAnnotation['data'],
    OverlayAnnotations.HTMLAnnotation['type']
  >
) {
  const { anchor, open, hide, show } = useModalState();
  return (
    <>
      {props.data.variant == 'Icon' ? (
        <Card key="inner" style={cardStyle} className="inheritTransform">
          <div className="rc-flex rc-justify-center rc-items-center rc-w-full rc-h-full">
            <Modal isOpen={open} toggle={hide}>
              <div
                style={{
                  height: '30rem',
                  width: '40rem',
                  maxHeight: '100%',
                  maxWidth: '100%',
                }}
              >
                <div className="rc-container rc-w-full rc-h-full rc-p-2 inheritTransform htmlEditor">
                  <div className="rc-overflow-hidden rc-h-full rc-w-full">
                    <div className="rc-prose">
                      <FroalaEditorView
                        config={froalaConfig}
                        model={props.data.html}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Modal>
            <Button
              className="rc-pointer-events-auto rc-touch-auto rc-flex rc-flex-col rc-items-center rc-justify-center rc-h-full rc-w-full rc-gap-2"
              ref={anchor as React.RefObject<HTMLButtonElement>}
              onClick={show}
            >
              <i className="fe fe-file-text" />{' '}
              <span className="rc-text-nowrap">Note</span>
            </Button>
          </div>
        </Card>
      ) : (
        <div className="rc-container rc-h-full rc-w-full rc-p-2 inheritTransform htmlEditor rc-pointer-events-auto rc-touch-auto">
          <div className="rc-overflow-hidden rc-h-full rc-w-full">
            <div className="rc-prose">
              <FroalaEditorView config={froalaConfig} model={props.data.html} />
            </div>
          </div>
        </div>
      )}
      <InteractionPreventer enabled={props.editing} />
    </>
  );
});
